<template>
  <div class="wrapper">
    <div class="p-4" v-if="fromPage == 'approval-deal'">
      <el-button class="tips-btn" @click="goBack()"> 返回 </el-button>
    </div>
    <div style="height: 100%" v-loading="mainLoding">
      <div v-if="!!auditInfo">
        <el-form :model="ruleForm" ref="ruleForm" label-width="180px" class="demo-ruleForm">
          <el-form-item label="申请人：" prop="name">
            {{ applicant }}
          </el-form-item>
          <el-form-item label="调查员到手金额（元）：" prop="money">
            {{ totalAmount }}
          </el-form-item>
          <el-form-item label="服务费（元）：">
            {{ rateAmount }}
          </el-form-item>
          <el-form-item label="结算总费用（元）：">
            {{ rateAfter }}
          </el-form-item>
          <el-form-item label="审批流程：" prop="load">
            <el-steps direction="vertical" :active="activeFlow" finish-status="success">
              <el-step v-for="(f, idx) in flow" :key="idx">
                <template v-slot:title> {{ f.assigneeName }} {{ f.statusText }} </template>
              </el-step>
            </el-steps>
          </el-form-item>
          <el-form-item label="涉及的结算单列表：" prop="link" class="mb-1">
            <div class="flex justify-end" v-if="type != 1">
              <div class="inline-block">
                <el-button class="tips-btn" @click="DownloadExportPDF"> 导出PDF </el-button>
                <el-button class="tips-btn" type="primary" @click="DownloadExportDetailExcel"> 导出Excel </el-button>
              </div>
            </div>
          </el-form-item>
          <data-table
            cell-class-name="truncate-table-cell-wrap"
            :index="true"
            :indexFixed="true"
            :page="page"
            :data="data"
            :columns="option.column"
            :loading="loading"
          >
            <!-- 结算状态 -->
            <template #settleStatus="{ row }">
              <div :class="[settleStatusColorMap[row.settleStatus], 's-status']">
                {{ settleStatusMap[row.settleStatus] }}
              </div>
            </template>
            <!-- 调价说明 -->
            <template #adjustDescribe="{ row }">
              <div style="text-align: left" v-if="row.adjustAmount">
                <p>调价人：{{ row.adjusterName }}，调整时间：{{ row.adjustTime }}，</p>
                <p>调整说明：{{ row.adjustDescribe }}</p>
              </div>
            </template>
            <!-- 支付方式 -->
            <template #payType="{ row }">
              <span>{{ payTypeMapCrud[row.payType] }}</span>
            </template>
          </data-table>
          <el-form-item label="涉及答卷：">
            <el-button type="text" @click="toAnswerDetail">查看</el-button>
          </el-form-item>
          <el-form-item label="备注：" prop="desc"> {{ remark }}</el-form-item>
          <el-form-item v-if="canAudit && type != 1">
            <el-button @click="refuse" type="primary" style="margin-left: 27vw">拒绝</el-button>
            <el-button @click="submit">同意</el-button>
          </el-form-item>
          <el-form-item v-if="type == 1 && showCancelAudit0">
            <el-button @click="revoke" type="danger" style="margin-left: 13vw">撤销审批</el-button>
          </el-form-item>
        </el-form>
        <div class="count-down" v-if="countDownVisible">{{ seconds }} 秒后返回前一页面</div>
        <el-dialog title="拒绝付款审批" :visible.sync="refuseDialogVisible" width="30%">
          <div>
            <span class="text-red">*</span>备注：
            <el-input
              type="textarea"
              style="margin-left: 45px; margin-top: -20px; width: 85%"
              :rows="2"
              placeholder="请输入内容"
              v-model="textarea2"
            >
            </el-input>
            <el-row style="margin-top: 30px; text-align: center">
              <el-button @click="refuseDialogVisible = false">取消</el-button>
              <el-button @click="doneRefuse" type="primary">拒绝</el-button>
            </el-row>
          </div>
        </el-dialog>
        <el-dialog title="撤销审批" :visible.sync="revokeDialogVisible" width="70%" style="left: -10px" :modal="false">
          <div>
            <div>当前财务付款审批涉及以下结算单，撤销审批后，以下结算单将同时撤销审批。</div>
            <data-table
              cell-class-name="truncate-table-cell-wrap"
              :index="true"
              :indexFixed="true"
              :page="page"
              :data="data"
              :columns="option.column"
              :loading="loading"
            >
              <!-- 结算状态 -->
              <template #settleStatus="{ row }">
                <div :class="[settleStatusColorMap[row.settleStatus], 's-status']">
                  {{ settleStatusMap[row.settleStatus] }}
                </div>
              </template>
              <!-- 调价说明 -->
              <template #adjustDescribe="{ row }">
                <div style="text-align: left" v-if="row.adjustAmount">
                  <p>调价人：{{ row.adjusterName }}，调整时间：{{ row.adjustTime }}，</p>
                  <p>调整说明：{{ row.adjustDescribe }}</p>
                </div>
              </template>
              <!-- 支付方式 -->
              <template #payType="{ row }">
                <span>{{ payTypeMapCrud[row.payType] }}</span>
              </template>
            </data-table>
            <el-row style="margin-top: 30px; margin-left: 350px">
              <el-button @click="revokeDialogVisible = false">暂不撤销</el-button>
              <el-button @click="doneRevoke" type="danger" v-loading="revokeLoading">撤销审批</el-button>
            </el-row>
          </div>
        </el-dialog>
        <el-dialog
          :title="`问卷名称：${surveyTitle}（${surveyId}）`"
          :visible.sync="answerDetailDialogVisible"
          width="80%"
          :modal="false"
          :destroy-on-close="true"
          :before-close="onAnswerDetailDialogClose"
        >
          <SettlementAnswerDetail
            ref="answerDetail"
            v-if="surveyId"
            :settleType="settleType"
            :surveyId="surveyId"
            :surveyTitle="surveyTitle"
            :statementId="statementId"
          >
          </SettlementAnswerDetail>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { confirmPay } from '@/api/wenjuan/reward'
import rechargeMixin from '@/mixins/recharge-mixins'
import { transformLoadingFunction } from '@/assets/js/el-loading'
import { getRechargeResult } from '@/assets/js/pay'
import {
  getSettlementPayInfo,
  cancelPaySettlement,
  auditPaySettlement,
  statementExportPDF,
  statementExportExcel
} from '@/api/wenjuan/settlement'
import { settlementBillListOptions as offlineOpt } from '@/views/survey/settlement/offline/options.js'
import { settlementBillListOptions as proxyOpt } from '@/views/survey/settlement/proxy/options.js'
import { settlementBillListOptions as visitorOpt } from '@/views/survey/settlement/visitor/options.js'
import { getStore } from '@dygc/shared'
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import { payTypeMapCrud } from '@/assets/js/config/payTypeMap'
import SettlementAnswerDetail from './SettlementAnswerDetail'

export default {
  name: 'PaymentApproval',
  components: { DataTable, SettlementAnswerDetail },
  props: {
    processInstanceId: {
      type: String,
      default: ''
    },
    includeStatementIds: {
      type: String,
      default: ''
    },
    userDygcStaffId: {
      type: [String, Number],
      default: null
    },
    type: {
      // 1为来自列表，0为来自链接
      type: Number,
      default: 0
    },
    showCancelAudit: {
      // 撤销按钮显示
      type: Boolean,
      default: true
    },
    fromPage: {
      type: String,
      default: ''
    }
  },
  mixins: [rechargeMixin],
  data() {
    let opt = {}
    let offlineOptions = Object.assign({}, offlineOpt, opt)
    let proxyOptions = Object.assign({}, proxyOpt, opt)
    let visitorOptions = Object.assign({}, visitorOpt, opt)

    offlineOptions.column = [...offlineOptions.column]
    proxyOptions.column = [...proxyOptions.column]
    visitorOptions.column = [...visitorOptions.column]

    offlineOptions.column.splice(offlineOptions.column.length - 1, 1)
    proxyOptions.column.splice(proxyOptions.column.length - 1, 1)
    visitorOptions.column.splice(visitorOptions.column.length - 1, 1)
    return {
      answerDetailDialogVisible: false,
      revokeLoading: false,
      showCancelAudit0: this.showCancelAudit,
      mainLoding: false,
      revokeDialogVisible: false, // 撤销审批 弹窗
      offlineOptions, // 面访
      proxyOptions, // 委托代理 委托对代理
      visitorOptions, // 委托代理 代理对调查员
      option: offlineOptions,
      loading: false,
      data: [], // 结算单详情表格数据
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      settleStatusMap: {
        1: '未发起',
        2: '待确认',
        3: '不认可',
        4: '已确认',
        5: '已撤销',
        6: '已结算',
        7: '已打款',
        8: '审批中',
        9: '审批已撤销',
        10: '审批拒绝'
      },
      settleStatusColorMap: {
        1: 'no-start',
        2: 'confirming',
        3: 'refused',
        4: 'confirmed',
        5: 'cancelled',
        6: 'settled',
        7: 'paid',
        8: 'approvaling',
        9: 'approvaling',
        10: 'approvaling'
      },
      approvalType: '', //区分审批类型，红包or费用结算
      auditInfo: null, // 奖励信息
      isSettlement: false, // 结算页面
      isConfirmPayment: false, // 支付页面
      isResultPayment: false, // 充值结果页面
      isPaymentSuccess: false, // 是否支付成功
      //auditing: false, // 是否还需要审批
      flow: [], // 审批流
      activeFlow: 0, // 当前审批流
      flowMap: {
        '-1': '已驳回',
        0: '已拒绝',
        1: '已同意',
        2: '已提交',
        3: '审批中',
        4: '已撤销',
        null: '待审批'
      },
      ruleForm: {
        name: '',
        money: '',
        desc: ''
      },
      textarea2: '', //拒绝备注
      paymentInfo: {
        price: 0.0, // 红包单价
        quantity: 0, // 红包数量
        type: '', // 类型 答题红包 or 分享红包
        isHead: false, // 是否是第一个弹出
        balance: 0,
        status: 0, // 固定金额 or 随机金额
        minNum: '', // 红包最小金额
        maxNum: '', // 红包最大金额
        totalSum: 0, //红包总额
        randomQuantity: 0, //随机红包数量
        auditItem: null //当前审核中的
      },
      params: {},
      refuseDialogVisible: false, // 拒绝 弹窗
      seconds: 3, // 关闭页面 倒计时描述
      countDownVisible: false,
      isPayer: false, //是否为付款人
      confirmInfo: {}, //二次确认弹窗信息
      canAudit: false, // 是否能审核
      payTypeMapCrud,
      settleType: 2,
      statementId: '',
      surveyId: '',
      surveyTitle: ''
    }
  },
  computed: {
    remark({ auditInfo }) {
      return auditInfo ? auditInfo.remark : ''
    },
    applicant({ auditInfo }) {
      if (!auditInfo) return ''
      return auditInfo.applicantName
    },
    previewUrl({ auditInfo }) {
      return auditInfo ? auditInfo.url : ''
    },
    totalAmount({ auditInfo }) {
      if (!auditInfo) return ''
      return parseFloat(auditInfo.totalYuanAmount).toFixed(2)
    },
    rateAmount({ auditInfo }) {
      if (!auditInfo) return ''
      return parseFloat(auditInfo.rateAmount).toFixed(2)
    },
    rateAfter({ auditInfo }) {
      if (!auditInfo) return ''
      return parseFloat(auditInfo.rateAfter).toFixed(2)
    },
    companyId() {
      return GlobalConfig.getCompanyId()
    }
  },
  methods: {
    onAnswerDetailDialogClose() {
      this.$refs.answerDetail.$refs.sf.reset()
      this.answerDetailDialogVisible = false
    },
    DownloadExportPDF() {
      let params = {
        proInstanceId: this.processInstanceId,
        settleType: this.settleType,
        surveyId: this.surveyId
      }
      statementExportPDF(params)
        .then(res => {
          window.open(res.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    DownloadExportDetailExcel() {
      let params = {
        proInstanceId: this.processInstanceId,
        settleType: this.settleType,
        surveyId: this.surveyId
      }
      statementExportExcel(params)
        .then(res => {
          window.open(res.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    toAnswerDetail() {
      this.answerDetailDialogVisible = true
    },
    countDownSeconds() {
      this.countDownVisible = true
      let interval = setInterval(() => {
        if (this.seconds == 0) {
          window.history.go(-1)
          this.countDownVisible = false
          clearInterval(interval)
        }
        this.seconds--
      }, 1000)
    },
    goBack() {
      window.history.go(-1)
    },
    resetFlag(done) {
      this.isSettlement = false
      this.isConfirmPayment = false
      this.isResultPayment = false
      this.isPaymentSuccess = false
      done && done()
    },
    submit() {
      if (this.isPayer) {
        const h = `<p>审批通过后，
          <span class="text-red">企业结算账户将支出¥${this.confirmInfo.rateAfter}（发放金额¥${this.confirmInfo.totalYuanAmount}，服务费¥${this.confirmInfo.rateAmount}），操作不可撤销</span>
          ，确认通过吗？</p>
        `
        this.$confirm(h, '付款确认', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '通过',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.handleAuditPaySettlement()
          })
          .catch(() => {})
      } else {
        this.handleAuditPaySettlement()
      }
    },
    handleAuditPaySettlement() {
      auditPaySettlement({
        procTaskId: this.auditInfo.procTaskId,
        pass: true,
        comment: this.textarea2,
        companyId: this.companyId,
        staffId: this.userDygcStaffId
      }).then(res => {
        //code = 2 时余额不足
        if (res.data.code == 2) {
          const h = `
            <span class="text-red">你的结算审批余额不足（¥${res.data.data.availableYuanAmount}）</span>
            ，无法通过审批，请联系企业管理充值或为您分配更多金额。
          `
          this.$confirm(h, '可用余额不足', {
            dangerouslyUseHTMLString: true,
            cancelButtonText: '关闭',
            type: 'error'
          })
            .then(() => {})
            .catch(() => {})
          return
        } else if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.activeFlow++
        //this.auditing = false
        this.canAudit = false
        this.auditItem.statusText = '已同意'
        this.updateTable()
      })
    },
    updateTable() {
      let params = {}
      if (this.processInstanceId) {
        params.processInstanceId = this.processInstanceId
      } else if (this.includeStatementIds) {
        params.includeStatementIds = this.includeStatementIds
      }
      this.loading = true
      getSettlementPayInfo(params).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
          this.loading = false
          return
        }
        this.data = res.data.data.statements
        this.data.forEach(item => {
          item.totalAmount = Number(item.totalAmount)
            ? (Number(item.totalAmount) / 100).toFixed(2)
            : Number(item.totalAmount).toFixed(2)
          item.realAmount = Number(item.realAmount)
            ? (Number(item.realAmount) / 100).toFixed(2)
            : Number(item.realAmount).toFixed(2)
          item.serviceFee = Number(item.serviceFee)
            ? (Number(item.serviceFee) / 100).toFixed(2)
            : Number(item.serviceFee).toFixed(2)
          item.totalSettlement = Number(item.totalSettlement)
            ? (Number(item.totalSettlement) / 100).toFixed(2)
            : Number(item.totalSettlement).toFixed(2)
          item.adjustAmount = Number(item.adjustAmount) ? (Number(item.adjustAmount) / 100).toFixed(2) : ''
        })
        this.loading = false
        this.countDownSeconds()
      })
    },
    getSettlementPayInfo() {
      let params = {}
      if (this.processInstanceId) {
        params.processInstanceId = this.processInstanceId
      } else if (this.includeStatementIds) {
        params.includeStatementIds = this.includeStatementIds
      }
      this.mainLoding = true
      getSettlementPayInfo(params).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
          this.mainLoding = false
          return
        }
        this.auditInfo = res.data.data
        let settleType = this.auditInfo.statements[0] && this.auditInfo.statements[0].settleType
        if (settleType == 0) {
          this.option = this.proxyOptions
        } else if (settleType == 1) {
          this.option = this.visitorOptions
        } else if (settleType == 2) {
          this.option = this.offlineOptions
        }
        this.settleType = settleType
        this.surveyId = this.auditInfo.statements[0].surveyId
        this.surveyTitle = this.auditInfo.statements[0].surveyTitle
        let array = []
        this.data = this.auditInfo.statements
        this.data.forEach(item => {
          item.totalAmount = Number(item.totalAmount)
            ? (Number(item.totalAmount) / 100).toFixed(2)
            : Number(item.totalAmount).toFixed(2)
          item.realAmount = Number(item.realAmount)
            ? (Number(item.realAmount) / 100).toFixed(2)
            : Number(item.realAmount).toFixed(2)
          item.serviceFee = Number(item.serviceFee)
            ? (Number(item.serviceFee) / 100).toFixed(2)
            : Number(item.serviceFee).toFixed(2)
          item.totalSettlement = Number(item.totalSettlement)
            ? (Number(item.totalSettlement) / 100).toFixed(2)
            : Number(item.totalSettlement).toFixed(2)
          item.adjustAmount = Number(item.adjustAmount) ? (Number(item.adjustAmount) / 100).toFixed(2) : ''
          array.push(item.id)
        })
        this.statementId = array.join(',')
        let auditing = false
        //let currentAudit = false
        this.isPayer = res.data.data.payer //当前登陆人是否为付款人
        this.canAudit = res.data.data.canAudit
        //二次确认弹窗信息
        this.confirmInfo = {
          totalYuanAmount: res.data.data.totalYuanAmount,
          rateAmount: res.data.data.rateAmount,
          rateAfter: res.data.data.rateAfter
        }
        this.flow = (this.auditInfo.taskFlows || []).map((item, index) => {
          if (item.action === 0) {
            item.statusText = '已拒绝'
          } else if (item.action === 1) {
            item.statusText = '已同意'
            this.activeFlow = index + 1
          } else if (item.action === 4) {
            item.statusText = '已撤销'
          } else {
            if (auditing) {
              item.statusText = '待审批'
            } else {
              item.statusText = '审批中'
              this.auditItem = item
              auditing = true
            }
          }
          //let assignee = (item.assignee || '').split('@')[0]
          // if (assignee == this.userDygcStaffId && item.action === 1) {
          //   currentAudit = true
          // } else {
          //   currentAudit = false
          // }
          return item
        })
        // this.auditing = auditing
        // if (currentAudit) {
        //   this.auditing = false
        // }
        this.mainLoding = false
      })
    },
    refuse() {
      this.refuseDialogVisible = true
    },
    doneRefuse() {
      if (!this.textarea2.trim()) {
        this.$message.error('请填写拒绝原因')
        return
      }
      auditPaySettlement({
        procTaskId: this.auditInfo.procTaskId,
        pass: false,
        comment: this.textarea2,
        companyId: this.companyId,
        staffId: this.userDygcStaffId
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.refuseDialogVisible = false
        //this.auditing = false
        this.canAudit = false
        this.auditItem.statusText = '已拒绝'
        this.updateTable()
      })
    },
    revoke() {
      this.revokeDialogVisible = true
    },
    doneRevoke() {
      let params = {}
      if (this.processInstanceId) {
        params.processInstanceId = this.processInstanceId
      } else if (this.includeStatementIds) {
        params.includeStatementIds = this.includeStatementIds
      }
      this.revokeLoading = true
      cancelPaySettlement(params)
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            this.revokeLoading = false
            return
          }
          this.revokeDialogVisible = false
          this.showCancelAudit0 = false
          this.revokeLoading = false
          this.getSettlementPayInfo()
        })
        .catch(err => {
          this.revokeLoading = false
          this.$message.error('系统未知错误')
        })
    }
  },
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/envelopes.scss';

.show-head,
.show-body {
  @apply w-full flex justify-between;
  span {
    @apply flex-1 leading-9 text-center;
  }
}

.settlement {
  .show-sum {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/scss/envelopes.scss';
@import '~@/assets/scss/mixin.scss';

.confirm-payment {
  .envelopes-info-line {
    @apply text-medium-x;
    line-height: 36px;

    .ein {
      color: #555555;
    }

    .eil {
      color: #1a1a1a;
    }
  }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/scss/envelopes.scss';

.z-result-payment-wrapper {
  .result-payment-wrapper {
    margin: auto;
  }

  .tips-text {
    text-align: center;
  }

  .result-button {
    margin-top: 30px;
    text-align: center;
  }

  .result-right {
    display: inline-block;
  }
}
.count-down {
  text-align: center;
}

.demo-ruleForm {
  width: 90%;
  margin: auto;
}
.s-status {
  border-radius: 2px;
  width: 78px;
  display: inline-block;
  height: 26px;
}
.no-start {
  color: #cccccc;
  background: #ffffff;
  border: 1px solid #cccccc;
}
.confirming {
  color: #ff463a;
  background: #fff6ec;
  border: 1px solid #ff463a;
}
.refused {
  color: #ff9932;
  background: #fff6ec;
  border: 1px solid #ff9932;
}
.confirmed {
  color: #4996fe;
  background: #eff6ff;
  border: 1px solid #4996fe;
}
.cancelled {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.45);
}
.settled {
  color: #b2d799;
  background: #f0f9ea;
  border: 1px solid #b2d799;
}
.paid {
  color: #fff;
  background: #53a41d;
}
.approvaling {
  color: #333;
  background: #ffffff;
  border: 1px solid #333;
}
::v-deep .avue-crud__menu {
  min-height: 0px;
  height: 0;
}
::v-deep .el-card {
  overflow-y: auto;
}
.avue-crud {
  width: 98%;
  margin-bottom: 18px;
}
.el-step.is-vertical ::v-deep .el-step__title {
  line-height: 34px;
}
::v-deep .avue-crud__empty {
  padding: 0;
}
::v-deep .avue-empty__image img {
  display: inline-block;
}
</style>
